/**
 * Which notification pop-ups raised by websocket events a user sees. Mirrors
 * `NOTIFICATION_POPUP_SCOPES` in document-llm-api, which owns the values.
 */
export const NOTIFICATION_POPUP_SCOPES = [
  'ALL_CASES',
  'ACTIVE_CASE',
  'NONE',
] as const;

export type NotificationPopupScope = (typeof NOTIFICATION_POPUP_SCOPES)[number];

/** Every pop-up shows; the fallback until, or instead of, a loaded value. */
export const DEFAULT_NOTIFICATION_POPUP_SCOPE: NotificationPopupScope =
  'ALL_CASES';

export function isNotificationPopupScope(
  value: unknown,
): value is NotificationPopupScope {
  return (
    typeof value === 'string' &&
    (NOTIFICATION_POPUP_SCOPES as readonly string[]).includes(value)
  );
}

/**
 * Decides whether a websocket-driven pop-up is shown in this tab.
 * An event without a case id is case-less and is only hidden by `NONE`.
 */
export function isNotificationPopupAllowed(
  scope: NotificationPopupScope,
  activeCaseId: string | undefined,
  eventCaseId: string | undefined,
): boolean {
  switch (scope) {
    case 'ALL_CASES':
      return true;
    case 'NONE':
      return false;
    case 'ACTIVE_CASE':
      return !eventCaseId || eventCaseId === activeCaseId;
  }
}
